import { slice } from './slice';

export const teamsReducer = slice.reducer;
export * from './actions';
export * from './store';
